// extracted by mini-css-extract-plugin
export default {"card":"unknownFavouriteProduct_card__c8p5R","info":"unknownFavouriteProduct_info__3pa5u","image":"unknownFavouriteProduct_image__jzJ8X","like":"unknownFavouriteProduct_like__FflGj"};